import PrzelewyGetList from './przelewyGetList'
const data = () => {
    return PrzelewyGetList();  
};
export default data;